import React from "react";
import { ReactComponent as TicketRaised } from "../../../../assets/images/TicketRaisedSuccessfully.svg";
import { Button } from "../../../common/Button";
import { useNavigate } from "react-router-dom";
export const TicketRaisedSuccessfully = ({ supportID }) => {
  const navigate = useNavigate();
  return (
    <div className="p-4">
      <div className="flex justify-center items-center">
        <TicketRaised />
      </div>
      <div className="flex flex-col items-center gap-3  py-4">
        <h3 className="text-secondarytwo text-f20">Ticket Raised Successfully</h3>
        <p className="text-secondary text-f16 flex flex-wrap ">Our team will get back to you as soon <br /> as possible</p>
        <div className="text-secondarytwo text-f16">
          <span>Ticket no : </span>
          <span>{supportID}</span>
        </div>
      </div>
      <hr />
      <div className="pt-5">
        <Button onClick={() => { window.location.reload() }} classes="bg-white border-2 border-link font-semibold text-link px-4 py-2 text-f14 rounded w-full ">Back to Tickets</Button>
      </div>
    </div>
  );
};
